// src/pages/TermsPage.jsx
import React from "react";
import { useNavigate } from "react-router-dom";
import Page from "components/Page";
import SectionCard from "components/SectionCard";
import FooterCompact from "components/FooterCompact";
import Terms from "components/TermsOfService";

export default function TermsPage() {
  const navigate = useNavigate();

  return (
    <div className="flex min-h-screen flex-col bg-app text-app">
      <div className="flex flex-1 flex-col items-center bg-surface p-6">
        <div className="w-full">
          <button
            type="button"
            onClick={() => navigate(-1)}
            className="btn btn-ghost mb-4"
          >
            ← Back
          </button>

          <Page title="Terms of Service">
            <SectionCard>
              <Terms />
            </SectionCard>
          </Page>
        </div>
      </div>

      <FooterCompact />
    </div>
  );
}